import { render, staticRenderFns } from "./ExpedienteCreate.vue?vue&type=template&id=46126b67&scoped=true&"
import script from "./ExpedienteCreate.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCreate.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteCreate.vue?vue&type=style&index=0&id=46126b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46126b67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCheckbox,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VSelect,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
